import React from 'react';
import { t } from '@lingui/macro';
import { useTheme } from 'styled-components';

import { Flex, Heading } from '@rover/kibble/core';
import { Highlight as HighlightItem } from '@rover/rsdk/src/apiClient/latest/model/highlight';

import { useRevampProfileContext } from '../../hooks/useRevampProfileContext';

import Highlight from './components/Highlight';

const MAX_HIGHLIGHTS = 6;
const COLUMN_GAP = 56;
const HALF_COLUMN_GAP = COLUMN_GAP / 2;

const HighlightsSection = (): JSX.Element | null => {
  const theme = useTheme();
  const { sitterData, serviceType } = useRevampProfileContext();
  const service = sitterData.services.find((s) => s.slug === serviceType);
  const highlights = service
    ? [...sitterData.highlights, ...service.highlights]
    : [...sitterData.highlights];

  if (highlights.length === 0) return null;

  const sortedHighlights = highlights.toSorted((a, b) => a.rank - b.rank).slice(0, MAX_HIGHLIGHTS);

  return (
    <Flex
      flexDirection="column"
      gap="lg"
      borderBottom="1px solid"
      borderBottomColor={theme.colors.separator.primary}
      pb="8x"
      pt="6x"
    >
      <Heading size="400" webProps={{ responsive: false }} py="4x">{t`Highlights`}</Heading>
      <Flex
        flexDirection={['column', 'row']}
        flexWrap="wrap"
        sx={{ rowGap: '8px', columnGap: ['0px', `${COLUMN_GAP}px`] }}
      >
        {sortedHighlights.map((item: HighlightItem) => (
          <Flex
            key={`${item.title}-${item.rank}`}
            flex={['1 1 100%', `1 1 calc(50% - ${HALF_COLUMN_GAP}px)`]}
            py="1x"
          >
            <Highlight
              title={item.title}
              color={item.color}
              backgroundColor={item.backgroundColor}
              iconName={item.icon}
              descriptionTitle={item.descriptionTitle}
              description={item.description}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};
export default HighlightsSection;
